import { useEffect, useState } from "react";
import PageHeader from "../../../components/pageHeader/pageHeader";
import style from "./registrationFields.module.css";
// import Input from "../../../components/Input";
import Dropdown from "react-bootstrap/esm/Dropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import EditButton, { ViewButton } from "../../../components/CommonComponents/EditComponent/EditComponent";
import Input from "../../../components/CommonComponents/Input/Input";
import Paginator, { PaginatorForRDT } from "../../../components/CommonComponents/Paginator/Paginator";
import Table, { tableCustomStyles } from "../../../components/CommonComponents/Table/Table";
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import { BASE_URL } from "../../../constants/Constants";
import { TRegistrationField } from "../../../hooks/registration-field-hooks";
import { _axios } from "../../../utils/axios";
import { formatDate } from "../../../utils/date";
import EditRegistrationFieldDialog from "./EditRegistrationFieldDialog";

interface TickerItem {
  registration_field_id: number;
  placeholder_name: string;
  label_name: string;
  updated_date?: string; // Make it optional if it is not always present
  active: number;
  mandatory: number;
}

type ActionType = {
  type: null | "edit";
  field?: TRegistrationField;
};

const RegistrationFields = () => {
  const [action, setAction] = useState<ActionType>({ type: null });
  const onClose = () => setAction({ type: null });

  const [totalList, setTotalList] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [regestrationFields, setRegestrationFields] = useState([]);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<TickerItem>();
  const [selectedItemIndex, setSelectedItemIndex] = useState<number>(0);
  const [isGridView, setIsGridView] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [lastDate, setLastDate] = useState<string | null>(null);

  const getRegistrationFields = () => {
    console.log("Request Data:", {
      page: currentPage,
      limit: entriesPerPage,
      filters: selectedFilters,
      lastDate
    });
    _axios.post(`${BASE_URL}/api/registration-fields`,
      {
        "page": currentPage,
        "limit": entriesPerPage,
        filters: selectedFilters,
        lastDate
      })
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        setRegestrationFields(response.data.data)
        setTotalList(response.data.data.length)
        // handle success
        console.log(response);
      })
      .catch(function (error: any) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }

  useEffect(() => {
    getRegistrationFields()
  }, [selectedFilters, lastDate])

  const columns = [
    {
      name: 'Sr. No.',
      // selector: (row: any, rowIndex?: number) =>
      //   (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1,
      selector: (log: any, rowIndex: number | undefined) => {
        const serialNumber = (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1;
        return serialNumber.toString().padStart(3, '0');
      },
      sortable: false,
      grow: 0.5,
      width: "140px",
    },
    {
      name: 'Field Name',
      width: "400px",
      selector: (row: any, rowIndex?: number) => row.label_name,
      sortable: true,
      grow: 3,
    },
    {
      name: 'Last Publish Date',
      grow: 3,
      selector: (row: any, rowIndex?: number) => formatDate(new Date(row.updated_date)),
      sortable: true,
      sortFunction: (a: any, b: any) => {
        const dateA = new Date(a.updated_date);
        const dateB = new Date(b.updated_date);
        return dateA.getTime() - dateB.getTime();
      }
    },
    {
      name: 'Status',
      width: "180px",
      grow: 2,
      selector: (row: any, rowIndex?: number) => (
        <button
          className={row.active === 1 ? "activeButtonCss" : "inactiveButtonCss"}
        >
          {row.active === 1 ? "Active" : "Inactive"}
        </button>
      ),
      sortable: false,
    },
    {
      name: 'Created By',
      selector: (row: any) => row.created_by,
      cell: (row: any) => <span className="text-center">{row.created_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: 'Created On',
      selector: (row: any) => formatDate(new Date(row.created_on)),
      sortable: true,
      width: "170px",
    },
    {
      name: 'Modified By',
      selector: (row: any) => row.modified_by,
      cell: (row: any) => <span className="text-center">{row.modified_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: 'Modified On',
      selector: (row: any) => formatDate(new Date(row.modified_on)),
      sortable: true,
      width: "170px",
    },
    {
      name: 'Action',
      width: "140px",
      grow: 0.5,
      selector: (row: any, rowIndex?: number) => (
        // <img
        //   src={Edit}
        //   alt="Edit"
        //   onClick={() => { handleEditClick(row, rowIndex ?? 0) }}
        //   className="globalEditCss"
        // />
        <div className="flex space-x-2">
          <EditButton
            onClick={() => { 
              if(row?.field_type === 'select') setAction({ type: "edit", field: row as TRegistrationField })
              else handleEditClick(row, rowIndex ?? 0) 
            }}
          />
          <ViewButton
            disabled={true}
            onClick={function (): void {
              throw new Error("Function not implemented.");
            }}
          />
        </div>
      ),
      sortable: false,
    },

  ];

  const handleEditClick = (item: TickerItem, index: number) => {
    console.log("Edit button clicked:", item);
    setSelectedItem(item);
    setSelectedItemIndex(index)
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleInputChange = (e: { target: { name: string; value: string | boolean; }; }) => {
    const { name, value } = e.target;
    setSelectedItem((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdateClick = () => {
    if (selectedItem?.placeholder_name.length === 0) {
      ErrorToast("Please enter valid Placeholder")
      return
    }
    if (selectedItem?.label_name.length === 0) {
      ErrorToast("Please enter valid Label Name")
      return
    }
    const data = {
      placeholder_name: selectedItem?.placeholder_name,
      label_name: selectedItem?.label_name,
      mandatory: selectedItem?.mandatory,
      active: selectedItem?.active,
      registration_field_id: selectedItem?.registration_field_id
    }

    _axios.patch(`${BASE_URL}/api/registration-fields`, data)
      .then(function (response) {
        console.log('response', response);
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        getRegistrationFields()
        SuccessToast('Registration Field Updated')
        handleModalClose();
      })
      .catch(function (error) {
        if (error?.response?.data?.message) {
          ErrorToast(error?.response?.data?.message)
        }
        console.log('error', error);
      })

  };

  const handleDateChange = (date: Date | null) => {
    if (date) {
      const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      const dateString = adjustedDate.toISOString().split('T')[0];
      setLastDate(dateString);
      getRegistrationFields();
    } else {
      setLastDate(null);
    }
  };


  const dropdownContent = (
    <div className={style.dropdownBox}>
      <ul>
        <Dropdown.Menu show className={style.DropDropMenu}>
          <div className={style.dropContent}>
            <Dropdown.Header className={style.DropTile}>Registration Fields filter</Dropdown.Header>
            <ul>
              <li>
                <div className={style.dropdownCheck}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes('1')}
                    onChange={() => handleFilterChange("Active")}
                  />{" "} <label >Active Status</label>
                </div>
              </li>
              <li>
                <div className={style.dropdownCheck}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes('0')}
                    onChange={() => handleFilterChange("Inactive")}
                  />{" "}Inactive Status
                </div>
              </li>
              <li>
                <span className="text-sm pl-2"> Last Publish Date</span>
                <DatePicker
                  selected={lastDate ? new Date(lastDate) : null}
                  onChange={handleDateChange}
                  dateFormat="dd/MM/yyyy"
                  className="border border-black"
                  isClearable
                />
              </li>
            </ul>
          </div>
        </Dropdown.Menu>
      </ul>
    </div>
  );

  const handleFilterChange = (filter: string, value?: string | null) => {
    console.log("Filter:", filter);
    console.log("Value:", value);
    let filterValue;
    if (filter === "Active") {
      filterValue = "1";
    } else if (filter === "Inactive") {
      filterValue = "0";
    } else {
      filterValue = filter;
    }

    if (filter !== 'lastDate') {
      const index = selectedFilters.indexOf(filterValue);
      if (index === -1) {
        setSelectedFilters([...selectedFilters, filterValue]);
      } else {
        const updatedFilters = [...selectedFilters];
        updatedFilters.splice(index, 1);
        setSelectedFilters(updatedFilters);
      }
    }

    // Handle lastDate filter for input type
    // if (filter === 'lastDate') {
    //   setLastDate(value || null);
    //   getRegistrationFields();
    // }
  };

  return (
    <div>
      <div className={style.bodyBox}>
        {/* Main content here */}
        <PageHeader
          title="Registration Fields"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showSearchButton={true}
          showAdditionalButton={false}
          buttonTitle=""
          isGridView={isGridView}
          onGridIconClick={() => setIsGridView(!isGridView)}
          showFilterButton={true}
          dropdownContent={dropdownContent}
        />

        {isGridView ?
          <BoxComponent>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              {regestrationFields?.filter(
                (row: any) => row?.label_name?.toLowerCase().includes(searchQuery?.toLowerCase()))
                .map((row: any, index: number) => {
                  return (
                    <div className="p-4 rounded-2xl bg-white flex flex-col shadow-lg border border-gray-300">
                      <div className="flex justify-between items-center space-x-4 mb-4">
                        <button className={row.active === 1 ? "activeButtonCss" : "inactiveButtonCss"}>
                          {row.active === 1 ? "Active" : "Inactive"}
                        </button>
                        <div className="flex justify-center space-x-1">
                          {/* <img src={Edit} alt="Edit" onClick={() => handleEditClick(row, index)} className="globalEditCss" /> */}
                          <EditButton
                            onClick={() => handleEditClick(row, index)}
                          />
                          <ViewButton
                            disabled={true}
                            onClick={function (): void {
                              throw new Error("Function not implemented.");
                            }}
                          />
                        </div>
                      </div>
                      <div className="mb-2 flex text-[12px]">
                        <p className="font-bold text-base w-1/2">Field Name</p>
                        <p className="text-base mx-2">:</p>
                        <p className="text-base w-2/3">{row?.label_name}</p>
                      </div>
                      <div className="mb-2 flex text-[12px]">
                        <p className="font-bold text-base w-1/2">Last Publish Date</p>
                        <p className="text-base mx-2">:</p>
                        <p className="text-base w-2/3">{formatDate(new Date(row?.updated_date ?? ''))}</p>
                      </div>
                    </div>
                  )
                })
              }
            </div>
            <Paginator
              limit={entriesPerPage}
              page={currentPage}
              setPage={setCurrentPage}
              count={totalList || 0}
            />
          </BoxComponent>
          :
          <BoxComponent>
            <Table
              columns={columns}
              data={regestrationFields?.filter(
                (row: any) => row?.label_name?.toLowerCase().includes(searchQuery?.toLowerCase()))}
              customStyles={tableCustomStyles}
              paginationComponent={PaginatorForRDT} />
          </BoxComponent>
        }

        {showModal && selectedItem && (
          <div className={style.modalOverlay}>
            <div className={style.modal}>
              <h5 className={style.modelHeading}>Edit Field</h5>
              <hr className="mt-2" />
              <div className={style.dateWrapper}>
                {selectedItemIndex !== 5 && <div className={style.dateInput}>
                  <label className={style.boldLable}>Enter Label Name</label>
                  <Input
                    type="text"
                    placeholder="Name"
                    name="label_name"
                    value={selectedItem.label_name}
                    onChange={handleInputChange}
                  />
                </div>}
                {selectedItemIndex !== 3 && <div className={style.dateInput}>
                  <label className={style.boldLable}>Input Box Placeholder</label>
                  <Input
                    type="text"
                    placeholder="Enter Name Here"
                    name="placeholder_name"
                    onChange={handleInputChange}
                    value={selectedItem.placeholder_name}
                  />
                </div>}
              </div>

              <div className={style.wrapperToggle}>
                <div className={style.dateInput}>
                  <div className={style.footerActive}>
                    <label className={style.footerActive}>Mandatory</label>
                    <label className={style.toggleBtn}>
                      <input
                        type="checkbox"
                        checked={selectedItem.mandatory == 1}
                        onClick={() => handleInputChange({ target: { name: 'mandatory', value: selectedItem.mandatory == 1 ? '0' : '1' } })}
                        className={style.inputCheckbox}
                      />
                      <span className={style.slider}></span>
                    </label>
                  </div>
                </div>
                {selectedItemIndex > 2 && <div className={style.footerActive}>
                  <label className={style.footerActive}>Field Activate</label>
                  <label className={style.toggleBtn}>
                    <input
                      type="checkbox"
                      checked={selectedItem.active == 1} onClick={() => handleInputChange({ target: { name: 'active', value: selectedItem.active == 1 ? '0' : '1' } })}
                      className={style.inputCheckbox}
                    />
                    <span className={style.slider}></span>
                  </label>
                </div>}
              </div>

              <div className={style.buttonSection}>
                <button
                  // className={style.publishButton}
                  className="buttonCss"
                  onClick={handleUpdateClick}>
                  Update
                </button>
                <button
                  // className={style.closeButton}
                  className="closeButtonCss"
                  onClick={handleModalClose}>
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {action.type === "edit" && action.field && (
        <EditRegistrationFieldDialog
          field={action.field}
          open
          onClose={onClose}
          onSave={getRegistrationFields}
        />
      )}
    </div>
  );
};


export default RegistrationFields
